import { Body2, Button, FullscreenSpinner, YStack } from "@medbillai/ui";
import { ScreenView, type ScreenViewProps } from "../../components/ScreenView";
import { useRefetchRecords } from "../bill/records/useRecords";
import { useCoverage } from "./read/useCoverage";
import { CoverageRoot } from "./root/CoverageRoot";
import { PAGE_GUTTER } from "./surfaces";
import { useCoverageTabGate } from "./useCoverageTabGate";
const COLUMN_WIDTH = 560;
export type CoverageScreenProps = {
  screenViewProps?: Omit<ScreenViewProps, "children">;
};
export function CoverageScreen({
  screenViewProps
}: CoverageScreenProps) {
  useCoverageTabGate();
  const {
    read,
    error,
    refetch
  } = useCoverage();
  const refetchRecords = useRefetchRecords();
  return <ScreenView centerHorizontal stackProps={PAGE_GUTTER} widthLimit={COLUMN_WIDTH} backgroundColor="$surface1" onRefresh={() => Promise.all([refetch(), refetchRecords()])} {...screenViewProps} data-sentry-element="ScreenView" data-sentry-component="CoverageScreen" data-sentry-source-file="screen.tsx">
      {read ? <CoverageRoot read={read} /> : error ? <LoadFailed onRetry={() => void refetch()} /> : <FullscreenSpinner />}
    </ScreenView>;
}
export function LoadFailed({
  onRetry
}: {
  onRetry: () => void;
}) {
  return <YStack gap="$sp2" alignItems="center" paddingVertical="$sp4" data-sentry-element="YStack" data-sentry-component="LoadFailed" data-sentry-source-file="screen.tsx">
      <Body2 color="$textSubtle" data-sentry-element="Body2" data-sentry-source-file="screen.tsx">We couldn’t load your coverage.</Body2>
      <Button variant="secondary" fillWidth={false} onPress={onRetry} data-sentry-element="Button" data-sentry-source-file="screen.tsx">
        Try again
      </Button>
    </YStack>;
}